import Blue from "~/core";

new Blue({
	name: 'Market Button Dropdown',
	selector: '.market-button-dropdown',
	setup(root) {
		attachToggle(root);

		function attachToggle(rootElement) {
			const childLinks = [...rootElement.querySelectorAll('a')];

			rootElement.addEventListener('click', () => {
				const isDropdownOpen = rootElement.classList.contains('is-open');

				// prevent selecting child links when dropdown is closed
				childLinks.forEach(link => {
					const tabState = isDropdownOpen ? '-1' : '0';
					link.setAttribute('tabindex', tabState);
				});

				rootElement.classList.toggle('is-open');
			});

		}
	},
});
